import Vue from 'vue'

import {achost, DEFAULT_HEADERS} from '../constants';

const state = () => ({
    events: [],
})

const actions = {
    fetchEvents(context) {
        return Vue.axios.post(`${achost}/api/v1/shoebill/steam/list_user_events`, {}, {
            headers: DEFAULT_HEADERS
        }).then((resp) => {
            let events = resp.data.items;
            context.commit("setEvents", events);
            return events;
        })   
    },
    getToplist(context, payload) {
        return Vue.axios.post(`${achost}/api/v1/shoebill/steam/tiered_event_toplist`, {
            'event_id':  payload.eventId
        }, {
            headers: DEFAULT_HEADERS
        });
    }
}

const mutations = {
    setEvents(state, value) {
        state.events = value;
    },
}

export const events = {
    namespaced: true,
    actions,
    mutations,
    state
}